/**
 * Collection Filter Tracking
 * Triggers event when user applies filters on collection pages
 * Optimized with URL change detection and debouncing
 */

(function () {
  'use strict';

  let filterTriggered = false;
  let lastUrl = location.href;

  function triggerFilterEvent() {
    if (filterTriggered) return;
    
    filterTriggered = true;
    console.log('Filter applied - triggering filter event');

    // Use EventTracker if available
    if (window.EventTracker) {
      window.EventTracker.trigger('filter_event', {
        timestamp: new Date().toISOString(),
        url: window.location.href,
        page: window.location.pathname,
      }, 5000);
    } else {
      setTimeout(function () {
        if (typeof $ !== 'undefined') {
          $('html').trigger('filter_event');
        } else if (typeof jQuery !== 'undefined') {
          jQuery('html').trigger('filter_event');
        } else if (window.CustomEvent) {
          window.dispatchEvent(new CustomEvent('filter_event', { bubbles: true }));
        }
        console.log('✓ Event triggered: filter_event');
      }, 5000);
    }
  }

  // Debounce function for change detection
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Lazy attach event listeners
  let listenersAttached = false;

  function attachFilterListeners() {
    if (listenersAttached) return;
    listenersAttached = true;

    // Method 1: Detect filter form submissions
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (
        form.querySelector('input[name*="filter"]') ||
        form.querySelector('select[name*="filter"]') ||
        form.classList.contains('filter-form') ||
        form.closest('.collection-filters')
      ) {
        triggerFilterEvent();
      }
    });

    // Method 2: Detect filter checkbox/radio changes (debounced)
    const handleFilterChange = debounce(function (e) {
      const target = e.target;
      if (
        (target.type === 'checkbox' || target.type === 'radio') &&
        (target.name.includes('filter') || target.closest('.filter') || target.closest('[class*="filter"]'))
      ) {
        triggerFilterEvent();
      }
    }, 300);

    document.addEventListener('change', handleFilterChange);

    // Method 3: Detect filter select dropdown changes
    document.addEventListener('change', function (e) {
      const target = e.target;
      if (
        target.tagName === 'SELECT' &&
        (target.name.includes('sort') ||
          target.name.includes('filter') ||
          target.closest('.collection-filters') ||
          target.closest('[class*="filter"]'))
      ) {
        triggerFilterEvent();
      }
    });

    // Method 4: Detect filter button clicks
    document.addEventListener('click', function (e) {
      const target = e.target;
      if (
        target.classList.contains('filter-btn') ||
        target.classList.contains('apply-filter') ||
        target.closest('.filter-apply') ||
        (target.tagName === 'BUTTON' && target.closest('[class*="filter"]'))
      ) {
        triggerFilterEvent();
      }
    });

    console.log('Filter listeners attached');
  }

  // Method 5: Monitor URL changes (for AJAX filters) - optimized to 3 seconds
  const urlChangeInterval = setInterval(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      if (lastUrl.includes('filter') || lastUrl.includes('sort_by')) {
        triggerFilterEvent();
      }
    }
  }, 3000); // OPTIMIZATION: Reduced from 1s to 3s

  // Cleanup interval on page unload
  window.addEventListener('beforeunload', () => {
    clearInterval(urlChangeInterval);
  });

  // Attach listeners on first user interaction (optimized)
  ['mousemove', 'scroll', 'touchstart', 'click'].forEach((event) => {
    document.addEventListener(
      event,
      function () {
        attachFilterListeners();
      },
      { once: true, passive: true }
    );
  });

  // For very active users, also attach after a delay as fallback
  setTimeout(attachFilterListeners, 5000);
})();